



















































































import { Component, Mixins } from 'vue-mixin-decorator';
import DesignPathCreator from '@/components/mixin/DesignPathCreator.vue';

import * as JwtUtil from '@/common/JwtUtil';

import RepositoryFactory from '@/repository/RepositoryFactory';

import * as DesignCode from '@/classification/DesignCode';

@Component
export default class ExamNav extends Mixins<DesignPathCreator>(DesignPathCreator) {
  private userId = '';

  private isTop = false;

  private isLogin = false;

  private showNav = false;

  private navLogoUri = '';

  private navLogoAltText = '';

  private topMvLogoUri = '';

  private topMvLogoAltText = '';

  get storedExam() {
    return this.$store.state.exam;
  }

  private mounted() {
    const jwt = JwtUtil.getJwtInfo();
    this.isLogin = jwt != null;
    this.isTop = this.$route.path === this.paths.TOP;

    this.getExamInfo();

    if (this.isLogin) {
      this.getAccount();
    }
    window.addEventListener('scroll.nav', this.onScroll, true);
  }

  private beforeDestroy() {
    window.removeEventListener('scroll.nav', this.onScroll, true);
  }

  /**
   * 検定情報の取得
   */
  private getExamInfo() {
    if (this.storedExam !== null && this.storedExam.resources !== undefined) {
      this.bindLogo(this.storedExam.resources);
    } else {
      const ExamRepository = RepositoryFactory.get().exam;
      ExamRepository.getExam().then((response) => {
        if (response.status === 200 && response.data.resources !== undefined) {
          this.bindLogo(response.data.resources);
        }
      });
    }
  }

  /**
   * リソースからロゴをセット
   * @param resource リソース情報
   */
  bindLogo(resources: any) {
    resources.forEach((resource: any) => {
      if (resource.display_place_key === DesignCode.NAV_LOGO) {
        this.navLogoUri = resource.resource_uri;
        this.navLogoAltText = resource.alternative_text;
      } else if (resource.display_place_key === DesignCode.TOP_MV_LOGO) {
        this.topMvLogoUri = resource.resource_uri;
        this.topMvLogoAltText = resource.alternative_text;
      }
    });
  }

  /**
   * ユーザー情報取得
   * 取得したユーザーIDをナビゲーションに表示
   */
  async getAccount() {
    try {
      const AccountRepository = RepositoryFactory.get().account;
      await AccountRepository.getAccount().then((response) => {
        this.userId = response.data.user_id;
      }).catch(() => {
        JwtUtil.deleteJwt();
        this.$router.replace(this.paths.LOGIN);
      });
    } catch (e) {
      JwtUtil.deleteJwt();
      this.$router.replace(this.paths.LOGIN);
    }
  }

  /**
   * ログアウト
   * 成功時はSessionStorageのJWTを削除しログイン画面に遷移
   */
  async logout() {
    try {
      const AccountRepository = RepositoryFactory.get().account;
      await AccountRepository.logout().then(() => {
        JwtUtil.deleteJwt();
        this.$router.replace(this.paths.LOGIN);
      }).catch(() => {
        JwtUtil.deleteJwt();
        this.$router.replace(this.paths.LOGIN);
      });
    } catch (e) {
      JwtUtil.deleteJwt();
      this.$router.replace(this.paths.LOGIN);
    }
  }

  /**
   * 検定詳細画面に遷移します。
   *
   * @param ランクコード（Base64エンコードされたコード）
   */
  private transitionLogin() {
    if (this.$route.path !== this.paths.LOGIN) {
      this.$router.replace(this.paths.LOGIN);
    }
  }

  /**
   * スクロール時にナビゲーションの表示非表示を切り替える
   */
  onScroll(e: any) {
    if (e.target.scrollTop > 300) {
      this.showNav = true;
    } else {
      this.showNav = false;
    }
  }

  private scrollToAnchor(anchor: string) {
    this.$scrollTo(anchor);
  }

  get paths() {
    return this.$store.state.routerPath;
  }
}
